import {Component, effect} from '@angular/core';
import {CatalogoInterface} from '../../../../../interfaces/proyecto.interface';
import {forkJoin, Subscription} from 'rxjs';
import {NuevoProyectoComponent} from '../../nuevo-proyecto.component';
import {MessageService} from 'primeng/api';
import {isAlphaNumericValidEvent} from "../../../../../../shared/services/utils-service";
import {CatalogoService} from "../../../../../../shared/services/catalogo-service";
import {NuevoProyectoService} from "../../services/nuevo-proyecto.services";
import {InstitucionItem} from "../../../../../tramites/components/interfaces/tramites.interface";
import {DraftProjectService} from "../../../../services/draft-project.service";
import {filter} from "rxjs/operators";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

@Component({
    selector: 'generalidades-nuevo-proyecto',
    templateUrl: './generalidades-nuevo-proyecto.component.html',
    styleUrls: ['./generalidades-nuevo-proyecto.component.css']
})
export class GeneralidadesNuevoProyectoComponent {
    public naturalezaList: CatalogoInterface[] = []
    public tipoList: CatalogoInterface[] = []
    public entornoList: CatalogoInterface[] = []
    public regimenList: CatalogoInterface[] = []
    public usoSueloList: CatalogoInterface[] = []
    public sectores: CatalogoInterface[] = []
    public instituciones: InstitucionItem[] = []
    public showRegimen: boolean = false
    camposCompletos: boolean = false;
    private subscriptions: Subscription[] = [];
    private tieneProyectoDefinido: Boolean | null = null;
    maxDescripcion: number = 2000;

    constructor(private route: ActivatedRoute, private router: Router,private messageService: MessageService, private catalogoService: CatalogoService,
                private nuevoProyectoService: NuevoProyectoService, protected datosProyecto: NuevoProyectoComponent,protected draftProjectService : DraftProjectService) {
    }

    ngOnInit(): void {
        console.log(`ngOnInit ->${this.constructor.name}`);
        if (history.state?.forceReload) {
            this.loadData(); // Force reload when coming from the button click
        }
        // Listen for route param changes to reload data
        this.subscriptions.push(
            this.route.paramMap.subscribe(() => {
                console.log('Route params changed -> Reloading data');
                this.loadData();
            })
        );
        // Listen for NavigationEnd to reload data (handles menu navigation)
        this.subscriptions.push(
            this.router.events.pipe(
                filter(event => event instanceof NavigationEnd),
                filter(() => this.route.snapshot.firstChild === null) // Ensure it's not a child route
            ).subscribe(() => {
                console.log('Navigation ended -> Reloading data');
                this.loadData();
            })
        );
        // Ensure initial load only if the other triggers didn't already call it
        if (!history.state?.forceReload) {
            this.loadData();
        }
    }

    /*
         gets
         */
    get campoCompleto() {
        return this.datosProyecto.datosCompletosInformacionGral
    }

    // public naturalezaLista = effect(() => {
    //     this.naturalezaList = this.nuevoProyectoService.listaNaturaleza()
    // })
    // public tipoLista = effect(() => {
    //     this.tipoList = this.nuevoProyectoService.listaTipo()
    //
    //     console.log("@DEBUG local_tipoLista", this.tipoList.length);
    //     console.log("@DEBUG prj_tipoLista", this.nuevoProyectoService.listaTipo().length);
    // })
    // public entornoLista = effect(() => {
    //     this.entornoList = this.nuevoProyectoService.listaEntorno()
    // })
    // public regimenLista = effect(() => {
    //     this.regimenList = this.nuevoProyectoService.listaRegimen()
    // })
    // public usoSueloLista = effect(() => {
    //     this.usoSueloList = this.nuevoProyectoService.listaUsoSuelo()
    // })

    isCharactersValid(event: KeyboardEvent) {
        if (event.key) {
            isAlphaNumericValidEvent(event, 3);
        }
    }

    tipoProyecto(idTipoProyecto: string) {
       this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            idTipoProyecto: idTipoProyecto
        });
    }

    tipoSector(idProyectoSector: number) {
       this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            idProyectoSector: idProyectoSector
        });
    }

    setProyectoInstitucion(idProyectoInstitucion: number) {
       this.draftProjectService.draftProject.set({
            ...this.draftProjectService.draftProject(),
            idProyectoInstitucion: idProyectoInstitucion
        });
    }

    tipoProyectoEffect = effect(() => {
        if (this.draftProjectService.draftProject().idTipoProyecto != '') {
            console.log("Una de las propiedades cambió");
            if (this.draftProjectService.draftProject().idTipoProyecto == '4') {
                this.showRegimen = true
            } else {
                this.showRegimen = false
                this.draftProjectService.draftProject().idRegimen = ''
            }
        } else {
            this.showRegimen = false
            this.draftProjectService.draftProject().idRegimen = ''
        }
    }, {allowSignalWrites: true});

    private loadData() {
        let sources = [
            this.catalogoService.getCatalogo('proyecto_tipo'),
            this.catalogoService.getCatalogo('entorno'),
            this.catalogoService.getCatalogo('regimen'),
            this.catalogoService.getCatalogo('tipo_uso_suelo'),
            this.catalogoService.getCatalogo('naturaleza'),
            this.catalogoService.getCatalogo('proyecto_sector'),
            this.catalogoService.getInstituciones(true)
        ];
        forkJoin(sources).subscribe({
            next: ([tipo, entorno, regimen, usoSuelo, naturaleza, sectores, instituciones]) => {
                this.tipoList = tipo;
                this.entornoList = entorno;
                this.regimenList = regimen;
                this.usoSueloList = usoSuelo;
                this.naturalezaList = naturaleza;
                this.sectores = sectores;
                this.instituciones = instituciones;
            },
            error: (error) => {
                console.error(error);
            },
            complete: () => {
                console.log('Data loaded!');
            }
        });
    }
    ngOnDestroy(): void {
        console.log(`ngOnDestroy ->${this.constructor.name}`);
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
